import { GeneratedInvitationMessage } from "../../utils/invitationMessageGenerator"

interface MessaggiGeneratiSectionProps {
  generatedMessages: GeneratedInvitationMessage[]
  copiedStates: Record<string, boolean>
  onCopy: (message: string, key: string) => void
}

export default function MessaggiGeneratiSection({
  generatedMessages,
  copiedStates,
  onCopy,
}: MessaggiGeneratiSectionProps) {
  return (
    <div className="results-section">
      <div className="form-label">Messaggi generati</div>
      <div className="results-table-container">
        <table className="results-table">
          <thead>
            <tr>
              <th className="col-name">NOME INVITO</th>
              <th className="col-pin">PIN</th>
              <th className="col-action">COPIA</th>
            </tr>
          </thead>
          <tbody>
            {generatedMessages.map((generatedMessage) => {
              const rowKey = generatedMessage.invitationId

              return (
                <tr key={rowKey}>
                  <td className="col-name">{generatedMessage.invitationName}</td>
                  <td className="col-pin">{generatedMessage.pin}</td>
                  <td className="col-action">
                    {!copiedStates[rowKey] ? (
                      <button
                        type="button"
                        className="btn-copy"
                        onClick={() => onCopy(generatedMessage.message, rowKey)}
                      >
                        Copia
                      </button>
                    ) : (
                      <span className="copy-success">Copiato!</span>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
